import { wikiLangCodes } from 'lib/lang';
import { capitalizeString } from 'shared-helpers/common';

/**
 * Get all language options as an object with language code as key
 */
const getAllLanguageOptionsByLangCode = () => {
  const options: Record<
    string,
    {
      capitalizedName: string;
      hasFlagIcon: boolean;
      label: string;
      value: string;
    }
  > = {};

  wikiLangCodes.forEach((languageObject) => {
    options[languageObject.value] = {
      capitalizedName: capitalizeString(languageObject.label),
      hasFlagIcon: Boolean(languageObject.hasFlagIcon),
      label: languageObject.label,
      value: languageObject.value
    };
  });

  return options;
};

export default getAllLanguageOptionsByLangCode;
